var React = require('react');

function Experts (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.33301 13L12.6663 13","stroke":"#0A1C33","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M8 9.72727H12.676C13.1546 9.72727 13.566 9.38821 13.6575 8.91847L15 2.02674L10.9167 4.81818L8 1","stroke":"#0A1C33","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M8 9.72727H3.324C2.84544 9.72727 2.43395 9.38821 2.34245 8.91847L1 2.02674L5.08333 4.81818L8 1","stroke":"#0A1C33","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Experts.defaultProps = {"width":"13","height":"14","viewBox":"0 0 17 14","fill":"none"};

module.exports = Experts;

Experts.default = Experts;
